import { useState, useEffect } from "react";
import { useLang } from "@/i18n/LangContext";
import { isTossApp } from "@/lib/platform";

export default function ScrollToTop() {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);
  const [toss, setToss] = useState(false);

  useEffect(() => {
    setToss(isTossApp());
  }, []);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed right-6 z-50 w-10 h-10 rounded-full bg-gray-900 dark:bg-card-border text-white shadow-lg hover:bg-gray-700 dark:hover:bg-[#4a6d96] transition-all duration-200 flex items-center justify-center active:scale-90 ${
        toss ? "bottom-[72px]" : "bottom-6"
      }`}
      aria-label={t.common.scrollToTop}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="18 15 12 9 6 15" />
      </svg>
    </button>
  );
}
